import React, { FC, useEffect, useState } from 'react'
import { Grid, Tooltip, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { AppInfo, getAppInfo } from '../../utils/App'

const useStyles = makeStyles(() => ({
  version: {
    position: 'absolute',
    zIndex: 100000000,
    bottom: 5,
    paddingLeft: 10,
  },
}))

export const Version: FC = () => {
  const classes = useStyles()
  const [versionBEInfo, setVersionBEInfo] = useState<AppInfo>({
    version: 0,
    startTime: '-',
  })

  useEffect(() => {
    getAppInfo().then(setVersionBEInfo)
  }, [])

  return (
    <Tooltip
      title={
        <Grid container>
          <Grid item>
            <Typography>UI version {process.env.REACT_APP_VERSION}</Typography>
            <Typography>SERVER version {versionBEInfo?.version}</Typography>
            <Typography>Server start {versionBEInfo?.startTime}</Typography>
          </Grid>
        </Grid>
      }
      className={classes.version}
    >
      <Typography variant="subtitle1">
        v{process.env.REACT_APP_VERSION}/{versionBEInfo?.version}
      </Typography>
    </Tooltip>
  )
}
